import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import { useQuery } from '@apollo/client';

import * as globalSelectors from 'store/global/selectors';
import Main from 'containers/Main';
import {
  ListFeedPeriodDocument,
  ListFeedPeriodQueryVariables,
  ListFeedPeriodQuery
} from 'generated/products-graphql';
import { OTHER_ROUTES } from 'utils/routes';
import { productsClient } from 'apollo';
import LoadingSpinner from 'components/LoadingSpinner';
import * as actions from 'containers/AccessControl/actions';
import { AuthSession, useAuthSession } from '@spins/react-sso-provider';

const FeedLoader = () => {
  const authSession: AuthSession = useAuthSession();
  const dispatch = useDispatch();
  const history = useHistory();
  const clientId: string = useSelector(globalSelectors.clientIdSelector);
  const [feedLoaded, setFeedLoaded] = useState(false);

  useEffect(() => {
    if (clientId === 'destini') {
      history.push(OTHER_ROUTES.CHANGE_BRAND);
    }
  }, [clientId, history]);

  const { loading, error } = useQuery<ListFeedPeriodQuery, ListFeedPeriodQueryVariables>(
    ListFeedPeriodDocument,
    {
      client: productsClient,
      skip: !authSession.isLoggedIn,
      variables: { clientID: clientId },
      onCompleted: data => {
        if (data && data.listFeedPeriod) {
          const spinsArray = data.listFeedPeriod
            .filter(val => val.FEED_NAME === 'SPINS')
            .map(val => val.END_PERIOD_DATE);
          const spinsDate =
            spinsArray && spinsArray.length === 1 ? spinsArray[0].slice(0, 10) : null;
          const nielsenArray = data.listFeedPeriod
            .filter(val => val.FEED_NAME === 'Nielsen')
            .map(val => val.END_PERIOD_DATE);
          const nielsenDate =
            nielsenArray && nielsenArray.length === 1 ? nielsenArray[0].slice(0, 10) : null;

          dispatch(actions.setPeriodDate(spinsDate, nielsenDate));
          setFeedLoaded(true);
        }
      }
    }
  );

  if (!authSession.isLoggedIn) {
    return <Alert variant="danger">Please log in before continue.</Alert>;
  }

  if (error) {
    return (
      <Alert variant="danger">
        An error occurred while trying to get feed data for the current user.
      </Alert>
    );
  }

  if (loading || !feedLoaded) {
    return <LoadingSpinner centered />;
  }

  return <Main />;
};

export default FeedLoader;
